let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jPCc0")).then(() => parcelRequire('i5pZi'));